import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FinancialsRoutingModule } from './financials-routing.module';
import { FinancialReportComponent } from './components/financial-report/financial-report.component';
import { AgGridModule } from 'ag-grid-angular';
import { FinancialsService } from '../../services/modules/financials/financials.service';
import { FinancialsComponent } from './financials.component';
import { FinancialComponent } from './components/financial/financial.component';
import { DisbursementsComponent } from './components/disbursements/disbursements.component';
import { FormsModule } from '@angular/forms';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { DatePickerComponent } from '../../components/date-picker/date-picker.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [
    FinancialsComponent,
    FinancialReportComponent,
    FinancialComponent,
    DisbursementsComponent,
  ],
  imports: [
    CommonModule,
    FinancialsRoutingModule,
    AgGridModule,
    FormsModule,
    NgbDropdownModule,
    DatePickerComponent,
    SharedModule,
  ],
})
export class FinancialsModule {}
